/* eslint-disable max-len */
import pMap from 'p-map';
import { settings } from '../../config/settings';
import { contentApi, websitesApi } from '../api/apiConfig';
import * as apiRoutes from '../api/apiRoutes';

export const sendWebsitesBatchCmd = async (batch) => {
  return websitesApi.put(`${apiRoutes.webpages}/batch`, batch);
};

export const getWebsitesAndTemplatesCmd = async () => {
  const websites = await websitesApi.getAll(apiRoutes.websites, {}, { caching: { timeout: 5000 } });
  const webtemplates = await websitesApi.getAll(
    '/web/templates',
    {},
    { caching: { timeout: 5000 } },
  );

  return {
    websites,
    webtemplates,
  };
};

export const getDocumentWebpagesCmd = async (key) => {
  return websitesApi.getAll(
    apiRoutes.webpages,
    {
      externalReferencesContains: `/content/${key}`,
    },
    { caching: { timeout: 5000 } },
  );
};

// load all the webconfigurations for the given document
export const initDocumentWebsitesConfigurationCmd = async (documentKey) => {
  const configurations = await websitesApi.getAll(apiRoutes.webpages, {
    externalReferencesContains: `/content/${documentKey}`,
  });

  const websitesCache = new Map();

  await pMap(
    configurations,
    async (configuration) => {
      let website = websitesCache.get(configuration.website.href);
      if (!website) {
        website = await websitesApi.get(
          configuration.website.href,
          {},
          { caching: { timeout: 5000 } },
        );
        websitesCache.set(configuration.website.href, website);
      }
      configuration.website = {
        ...configuration.website,
        ...website,
      };

      if (configuration.options?.facets && configuration.options.facets.length > 0) {
        // eslint-disable-next-line no-restricted-syntax
        await pMap(
          configuration.options.facets,
          async (facet) => {
            if (facet.source) {
              try {
                const source = await contentApi.get(facet.source.href);
                facet.source = {
                  ...facet.source,
                  ...source,
                };
              } catch (e) {
                console.log('ERROR retrieving source:', facet.source.href, configuration);
              }
            }
          },
          { concurrency: 5 },
        );
      }
    },
    { concurrency: 5 },
  );

  return {
    keys: documentKey,
    configurations: configurations.map((c) => {
      return {
        ...c,
        oldLocations: c.oldLocations || [],
      };
    }),
  };
};

export const getWebpagesWithFacetContainingReferenceFrame = async (referenceFrameKey) => {
  const configurations = await websitesApi.getAll(apiRoutes.webpages, {
    'options.facetsContains': `/content/${referenceFrameKey}`,
  });
  return configurations;
};

export const recacheUrlsCmd = (webpages) => {
  if (!settings.prerender.enabled) {
    return;
  }
  webpages.forEach((w) => {
    const cacheUrl = `https://${w.website.domain}${w.path}`;
    const data = {
      prerenderToken: settings.prerender.token,
      url: cacheUrl,
    };
    fetch(settings.prerender.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  });
};
